// import 'core-js/features/object/assign'
// import 'core-js/features/object/values'
// import 'core-js/features/array/find'
// import 'core-js/features/object/entries'
// import 'core-js/features/promise'
// import 'core-js/features/array/from'
// import 'whatwg-fetch'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

// import 'core-js/fn/array/for-each'
// import 'core-js/fn/weak-set'
// import 'core-js/fn/string/ends-with'
// import 'core-js/fn/array/includes'
// import 'core-js/fn/number/is-nan'

import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import { serviceWorker, AppProvider } from './'
import { ModalProvider } from '../features/modals'
import ErrorBoundary from './provider/ErrorBoundary'
import { DevMode } from '../features/account'

export default props => (
  <ErrorBoundary>
    <ReduxProvider store={props.store}>
      <HashRouter>
        <AppProvider
          templates={props.templates}
          config={props.config}
          extend={props.extend}>
          <ModalProvider>
            {props.children}

            <DevMode />
          </ModalProvider>
        </AppProvider>
      </HashRouter>
    </ReduxProvider>
  </ErrorBoundary>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
